/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useGeneratedQuizz } from './generatedQuiz.hook';
import QuestionForm from '@/components/Views/QuestionForm/QuestionForm';
import { Button } from '@/components/Common';
import { useGeneratedModule } from '../GeneratedModule/generatedModule.hook';
import { QuestionType } from '@/api/gql/graphql';
import { QuizzFormValues } from '@/hooks/useQuizzForm';

const GeneratedQuizForm = ({ moduleId }: { moduleId: string }) => {
  const {
    QuizzQuestionType,
    registerUpdate,
    updateErrors,
    handleSubmitUpdate,
    setUpdateValue,
    handleSelectedType,
    selectedType,
    response1Check,
    setResponse1Check,
    response2Check,
    setResponse2Check,
    response3Check,
    setResponse3Check,
    response4Check,
    setResponse4Check,
    selectedGeneratedQuizz,
    resetUpdate,
    setGeneratedInitialSelectedOptions,
  } = useGeneratedQuizz();

  const { onSubmitGeneratedQuizz } = useGeneratedModule();

  useEffect(() => {
    const res1 = selectedGeneratedQuizz?.responses[0]?.isRight as boolean;
    const res2 = selectedGeneratedQuizz?.responses[1]?.isRight as boolean;
    const res3 = selectedGeneratedQuizz?.responses[2]?.isRight as boolean;
    const res4 = selectedGeneratedQuizz?.responses[3]?.isRight as boolean;

    setUpdateValue('name', selectedGeneratedQuizz?.name ?? undefined);
    setUpdateValue('reponse1', selectedGeneratedQuizz?.responses[0]?.response);
    setUpdateValue('reponse2', selectedGeneratedQuizz?.responses[1]?.response);
    setUpdateValue('reponse3', selectedGeneratedQuizz?.responses[2]?.response);
    setUpdateValue('reponse4', selectedGeneratedQuizz?.responses[3]?.response);
    setUpdateValue('description', selectedGeneratedQuizz?.description ?? '');
    setResponse1Check(res1);
    setResponse2Check(res2);
    setResponse3Check(res3);
    setResponse4Check(res4);
  }, [
    selectedGeneratedQuizz,
    selectedGeneratedQuizz?.description,
    selectedGeneratedQuizz?.name,
    selectedGeneratedQuizz?.responses,
    setResponse1Check,
    setResponse2Check,
    setResponse3Check,
    setResponse4Check,
    setUpdateValue,
  ]);

  const RenderEditButtons = () => {
    return (
      <div className="flex items-center gap-2 w-full">
        <Button
          type="button"
          onClick={() => {
            resetUpdate();
            setResponse1Check(false);
            setResponse2Check(false);
            setResponse3Check(false);
            setResponse4Check(false);
            setGeneratedInitialSelectedOptions &&
              setGeneratedInitialSelectedOptions(null);
          }}
          title="Annuler"
          className="mt-3 w-full  !bg-completed hover:!outline-complete hover:!text-completed hover:!bg-hoverColor  text-white !px-2"
        />
        <Button type="submit" title="Modifier" className="mt-3 w-full !px-2" />
      </div>
    );
  };

  const submitQuizzData = (formData: QuizzFormValues) => {
    if (moduleId) {
      onSubmitGeneratedQuizz(
        formData,
        moduleId,
        selectedGeneratedQuizz?._id,
        selectedType as QuestionType,
        response1Check,
        response2Check,
        response3Check,
        response4Check,
      );
    }
  };

  return (
    <QuestionForm
      QuizzQuestionType={QuizzQuestionType}
      register={registerUpdate}
      errors={updateErrors}
      handleSubmit={handleSubmitUpdate}
      onSubmit={submitQuizzData}
      setValue={setUpdateValue}
      handleSelectedType={handleSelectedType}
      selectedType={selectedType}
      response1Check={response1Check}
      setResponse1Check={setResponse1Check}
      response2Check={response2Check}
      setResponse2Check={setResponse2Check}
      response3Check={response3Check}
      setResponse3Check={setResponse3Check}
      response4Check={response4Check}
      setResponse4Check={setResponse4Check}
      initialSelectedOptions={{ _id: 1, name: selectedGeneratedQuizz?.type }}
      isEditable={true}
      editButtons={<RenderEditButtons />}
    />
  );
};

export default GeneratedQuizForm;
